if (!window.pendo) {
    if (!document.location.host.startsWith('localhost')) {
        ;(function (apiKey) {
            ;(function (p, e, n, d, o) {
                var v, w, x, y, z
                o = p[d] = p[d] || {}
                o._q = o._q || []
                v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']
                for (w = 0, x = v.length; w < x; ++w)
                    (function (m) {
                        o[m] =
                            o[m] ||
                            function () {
                                o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)))
                            }
                    })(v[w])

                y = e.createElement(n)
                y.async = !0
                y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js'
                z = e.getElementsByTagName(n)[0]
                z.parentNode.insertBefore(y, z)

                window.pendo = o
            })(window, document, 'script', 'pendo')
        })('8ce7d117-7449-4998-5ebe-9e938533365d')
    } else {
        window.pendo = {
            initialize() {
                console.log('pendo:initialize', [...arguments])
            },
            identify() {
                console.log('pendo:identify', [...arguments])
            },
            updateOptions() {
                console.log('pendo:updateOptions', [...arguments])
            },
            pageLoad() {
                console.log('pendo:pageLoad', [...arguments])
            },
            track() {
                console.log('pendo:track', [...arguments])
            },
        }
    }
}

export function track() {
    window.pendo.track(...arguments)
}

import { watchEffect } from 'vue'
import { gdpr } from './gdpr.js'
import { hasRole, jwt, roles } from './jwt.js'

let lastId = 0
let lastAnalytics = gdpr.analytics || false
let loaded = false

watchEffect(() => {
    const id = jwt.id || 0
    const analytics = gdpr.analytics || false

    if (id > 0 && gdpr.analytics && (lastId !== id || lastAnalytics !== analytics)) {
        window.pendo.initialize({
            visitor: {
                id: jwt.id,
                email: jwt.username,
                full_name: jwt.name,
                organizationId: jwt.organizationId,
            },
            account: {
                id: jwt.organizationId,
                name: jwt.organizationName,
                is_paying: hasRole(roles.subscribed),
            },
        })

        loaded = true

        lastId = id
        lastAnalytics = analytics
    } else if (!gdpr.analytics && loaded) {
        setTimeout(() => document.location.reload(), 0)
    }
})
